// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editor-margin {\n  margin-bottom: 30px;\n}\n\nh1 {\n  font-size: 18px;\n  font-weight: 900;\n  margin: 10px 0;\n  align-self: center;\n  line-height: 30px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
